import SubPage from './SubPage';

const CoronaVirusPage = () => <SubPage textKey="CoronaVirus.Text" />;

export default CoronaVirusPage;
